import { QuotationStatus, type QuotationDraft } from '../types/quotation.types';

// ── 14ykpqtr2kq — a re-selected quotation must not hide its finished post ─────────────────────────
// Re-selecting a quotation already open this session re-activates the cached copy without a fetch,
// and the live-event handlers only listen for the ACTIVE quotation. So when X finished posting while
// the user was on Y, X's "post finished" event was dropped: back on X, the cached copy still read
// Draft, the posting card no longer locked (a Done job leaves the outbox status projection), and the
// panel was editable although the quotation was already Submitted.

/** Posted states — the server copy is authoritative and the panel is read-only. */
export function isPostedQuotationStatus(status: QuotationStatus): boolean {
  return status === QuotationStatus.Submitted || status === QuotationStatus.Sent;
}

/**
 * Should re-selecting this cached quotation re-fetch it in the background? Only when THIS session
 * posted it (`postingDraftIds`, cleared once the result has been applied) and the cached copy can
 * still be behind: not already posted, and not dirty. A posted draft can't be dirty — posting saves
 * first, then locks editing — so a dirty copy means the user edited after a failed post, and the
 * cache is the truth there.
 */
export function shouldRefetchOnReactivate(
  draft: Pick<QuotationDraft, 'serverId' | 'status' | 'dirty'>,
  postingDraftIds: ReadonlySet<number>,
): boolean {
  if (draft.serverId == null) return false;
  if (!postingDraftIds.has(draft.serverId)) return false;
  if (isPostedQuotationStatus(draft.status)) return false;
  return !draft.dirty;
}
